import { Component, OnInit, ViewChild } from "@angular/core";
import { IContentHeader } from "../../../../../layout/components/content-header/content-header.component";
import { IProvider } from "../../../../providers/models/providers";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../../auth/service";
import { Router } from "@angular/router";
import { environment } from "../../../../../../environments/environment";
import { CostService } from "../../../cost.service";
import { ProvidersService } from "../../../../providers/providers.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ICommissionList } from "../../../../../auth/models/commission-interface";
import { IProviderCost } from "../../../models/provider-cost";
import { CommissionService } from "../../../../../auth/service/commission.service";
import moment from "moment/moment";
import { ICollaboratorCost } from "app/modules/collaborators/models/collaborator-costs";
import { CollaboratorsService } from "app/modules/collaborators/collaborators.service";

@Component({
  selector: "app-providers-cost-list",
  templateUrl: "./providers-cost-list.component.html",
  styleUrls: ["./providers-cost-list.component.scss"]
})
export class ProvidersCostListComponent implements OnInit {
  @ViewChild("table") table: any;
  public contentHeader: IContentHeader = null;
  public searchKey: string = null;
  public tableLimit: number = 10;
  public providers: IProvider[] = [];
  public providersCostList: IProviderCost[] = [];
  public filterProvidersCostList: IProviderCost[] = [];
  public selectedProviderCost: IProviderCost = null;
  public formGroup: FormGroup;
  public showErrors: boolean = false;
  public commissions: ICommissionList[] = [];
  public editMode: Boolean = false;
  public selectedMonth: string = moment().format("M");
  public selectedYear: string = moment().format("YYYY");
  public availableMonths: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
  public availableYears: string[] = [];
  public isSelectedAChild: boolean = false;
  private selectedParentId: number = null;
  public attachments_list: Array<any> = [];
  public attachments_list_obj: Array<any> = [];
  private childrenElementNumber: number = 1;
  public totalAmount: number = 0;
  public showEditField: { provider_id: boolean; amount: boolean; amount_description: boolean; commission_id: boolean; attachments: boolean; collaborator_id: boolean } = {
    provider_id: false,
    amount: false,
    amount_description: false,
    commission_id: false,
    attachments: false,
    collaborator_id: false
  };
  public parentProviderName: string = null;
  public collaboratorList: ICollaboratorCost[] = [];
  public filteredCollaborators: any = [];

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private _costService: CostService,
    private router: Router,
    public _providerService: ProvidersService,
    public _modalService: NgbModal,
    private formBuilder: FormBuilder,
    private _commissionService: CommissionService,
    private _collaboratorService: CollaboratorsService
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: "MENU.PROVIDERS_COST",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: "MENU.PROVIDERS_COST",
            isLink: false
          }
        ]
      }
    };

    this.formGroup = this.formBuilder.group({
      provider_id: [null, [Validators.required]],
      collaborator_id: [null],
      amount: [null, [Validators.required]],
      amount_description: [null, [Validators.required, Validators.maxLength(255)]],
      commission_id: [null]
    });
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_providers_cost")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    for (let i = 2023; i <= moment().year()+1; i++) {
      this.availableYears.push(String(i));
    }
    await this.loadData();
    this.commissions = await this._commissionService.getCommissions();
    await this.loadProviders();
    this._utilService.hideLoading();
  }

  async loadData() {
    this.totalAmount = 0;
    this.providersCostList = await this._costService.getProvidersCostList(Number(this.selectedMonth), Number(this.selectedYear)).then((providersCostList: any) => {
      return providersCostList.map((provider: any) => {
        this.totalAmount += Number(provider.amount);
        if (provider.logo) {
          provider.logo = environment.CDN_URL + "/" + provider.logo;
        }
        return provider;
      });
    });
    this.collaboratorList = await this._collaboratorService.getCollaboratorsCostList(this.selectedMonth, this.selectedYear);
    this.filteredCollaborators = this.collaboratorList.map((collaborator: any) => collaborator);
    this.search();
  }

  async loadProviders() {
    this.providers = await this._providerService.getList();
  }

  search(): void {
    let filteredArray: IProviderCost[] = this.providersCostList;

    if (this.searchKey && this.searchKey.length > 0) {
      const key: string = this.searchKey.toLowerCase();
      filteredArray = filteredArray.filter(
        (provider: IProviderCost) => provider.amount_description.toLowerCase().includes(key) || provider.provider.name.toLowerCase().includes(key) || (provider.provider.business_name || "").toLowerCase().includes(key)
      );
    }
    this.filterProvidersCostList = filteredArray;
  }

  updateTableLimit(event: { target: { value: string } }): void {
    this.tableLimit = Number(event.target.value);
  }

  formatLabel(month: number) {
    //Refactor della label filtro mese
    const date = moment();
    date.set("month", month - 1);
    return date.format("MMMM");
  }

  toggleExpandRow(row, expanded) {
    if (!expanded) {
      this.table.rowDetail.collapseAllRows();
    }
    if (row.children && row.children.length > 0) {
      this.childrenElementNumber = row.children.length;
    }
    this.table.rowDetail.toggleExpandRow(row);
  }

  async openModal(modal, cost, parent) {
    this._modalService.open(modal, {
      centered: true,
      size: "md",
      backdrop: false,
      keyboard: false
    });
    this.selectedProviderCost = cost;
    if (!!parent) {
      this.parentProviderName = parent.provider.name;
      this.isSelectedAChild = true;
      this.selectedParentId = parent.id;
      this.formGroup.patchValue({
        provider_id: parent.provider.id
      });
      this.filteredCollaborators = this.collaboratorList.filter((collaborator: ICollaboratorCost) => collaborator.provider_id === parent.provider.id);
    }
    if (!!this.selectedProviderCost) {
      this.editMode = true;
      this.formGroup.patchValue({
        provider_id: !!parent ? parent.provider.id : cost.provider.id,
        collaborator_id: cost.collaborator?.id || 0,
        amount: this._utilService.addDotsToNumber(cost.amount),
        amount_description: cost.amount_description,
        commission_id: cost && cost.commission && cost.commission.id ? cost.commission.id : null
      });

      this.filteredCollaborators = this.collaboratorList.filter((collaborator: ICollaboratorCost) => collaborator.provider_id === this.formGroup.value.provider_id);

    } else {
      //Nel crea mostriamo tutti i field
      this.showEditField = {
        provider_id: true,
        collaborator_id: true,
        amount: true,
        amount_description: true,
        commission_id: true,
        attachments: true
      };
    }
  }

  async handlerChaneProvider() {
    //reset description and amount
    this.formGroup.patchValue({
      amount_description: null,
      amount: null,
      collaborator_id: null
    });
    if (this.formGroup.value.provider_id) {
      this.filteredCollaborators = this.collaboratorList.filter((collaborator: ICollaboratorCost) => collaborator.provider_id === this.formGroup.value.provider_id);
    }
  }

  modalClose() {
    this.formGroup.patchValue({
      provider_id: null,
      amount: null,
      amount_description: null,
      commission_id: null
    });
    this.parentProviderName = null;
    this.showEditField = {
      provider_id: false,
      collaborator_id: false,
      amount: false,
      amount_description: false,
      commission_id: false,
      attachments: false
    };
    this.showErrors = false;
    this.formGroup.markAsUntouched();
    this.selectedParentId = null;
    this.editMode = false;
    this.isSelectedAChild = false;
    this.selectedProviderCost = null;
    this.attachments_list = [];
    this.attachments_list_obj = [];
    this._modalService.dismissAll();
  }

  formHasError(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  formatMoneyValue() {
    this.formGroup.patchValue({ amount: this._utilService.addDotsToNumber(this.formGroup.value.amount) });
  }

  toggleField(field: string) {
    //In caso il costo abbia dei figli l'importo non è editabile perché composto dalle sottocategorie

    if (field === "amount" && this.selectedProviderCost.children && this.selectedProviderCost.children.length > 0) {
      this._utilService.showSWALError({ text: "ERROR_IMPORT_PROVIDER_COST_NOT_EDITABLE" });
      return false;
    }
    this.showEditField[field] = !this.showEditField[field];
  }

  async addAttachmentToList(files: any) {
    // I create a variable from the actual list
    let updatedList: any[] = this.attachments_list_obj.filter((item: any) => item.name !== "");
    //For all files charged in the queue
    for (let file of files) {
      //check dimensions
      if (file.size > 10000000) {
        await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      //If exits in the list I'll remove it
      const exists: any = updatedList.find((item: any) => item.name === file.name);
      // If exists remove it
      if (exists) {
        updatedList = updatedList.find((item: any) => item.name === file.name);
      }
      //If it does not exist I'll add it
      else {
        this.attachments_list.push(file);
      }
      //Add to updated list
      updatedList.push({
        name: file.name,
        size: this._utilService.formatBytes(file.size),
        status: 0
      });
    }
    //I update the variable for the page
    this.attachments_list_obj = updatedList;
  }

  resetAttachmentsList() {
    this.attachments_list_obj = [];
    this.attachments_list = [];
  }

  removeAttachmentFromList(index: any) {
    this.attachments_list_obj = this.attachments_list_obj.filter((item: any, i: number) => i !== index);
    this.attachments_list = this.attachments_list.filter((item: any, i: number) => i !== index);
  }

  async uploadAttachments(providerCostId: number) {
    // I'll wait for all attachments to be uploaded
    await Promise.all(
      this.attachments_list.map((file: File) => {
        return this._costService.uploadAttachmentCostProvider(file, providerCostId);
      })
    ).catch(async () => {
      await this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE" });
    });
  }

  async deleteAttachment(id: number) {
    await this._utilService
      .showSWAL({
        title: "CONFIRM_DELETE_FILE",
        icon: "error",
        confirmButtonText: "CONFIRM_DELETE_BTN",
        customClass: {
          confirmButton: "btn btn-danger"
        }
      })
      .then(async (result) => {
        if (result.value) {
          await this._costService
            .deleteAttachmentProviderCost(id)
            .then(async () => {
              this.selectedProviderCost.attachments = this.selectedProviderCost.attachments.filter((item: any) => item.id !== id);
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_FILE" });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_DELETE_FILE" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT"
          });
        }
      });
  }

  async addNewCost() {
    if (!this._authenticationService.hasCapability("create_provider_cost")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (this.formGroup.invalid) {
      await this._utilService.showSWALError({ text: "COMPILE_ALL_FIELD" });
      return false;
    }
    this._utilService.showLoading();
    await this._costService
      .createProviderCost({
        ...this.formGroup.value,
        month: this.selectedMonth,
        year: this.selectedYear,
        parent_id: this.isSelectedAChild ? this.selectedParentId : null
      })
      .then(async (res: IProviderCost) => {
        if (this.attachments_list && this.attachments_list.length > 0) {
          this._utilService.hideLoading();
          await this.uploadAttachments(res.id);
        }
        this.modalClose();
        await this.loadData();
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_PROVIDER_COST" });
      })
      .catch((err: any) => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_CREATE_PROVIDER_COST" });
        console.error(err);
      });
  }

  async editCost() {
    if (!this._authenticationService.hasCapability("edit_provider_cost")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (this.formGroup.invalid) {
      await this._utilService.showSWALError({ text: "COMPILE_ALL_FIELD" });
      return false;
    }
    let data: IProviderCost = {
      ...this.formGroup.value,
      month: this.selectedProviderCost.month,
      year: this.selectedProviderCost.year,
      parent_id: this.isSelectedAChild ? this.selectedParentId : null
    };
    this._utilService.showLoading();
    await this._costService
      .editProviderCost(this.selectedProviderCost.id, data)
      .then(async () => {
        if (this.attachments_list && this.attachments_list.length > 0) {
          this._utilService.hideLoading();
          await this.uploadAttachments(this.selectedProviderCost.id);
        }
        this.modalClose();
        await this.loadData();
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_PROVIDER_COST" });
      })
      .catch((err: any) => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EDIT_PROVIDER_COST" });
        console.error(err);
      });
  }

  async delete(provider: IProviderCost) {
    if (!this._authenticationService.hasCapability("delete_provider_cost")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_COST");
    deleteText += ` ${!!provider && provider.provider?.name ? provider.provider?.name : provider.amount_description}`;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._costService
            .deleteCostProvider(provider.id)
            .then(async () => {
              this._utilService.hideLoading();
              await this.loadData();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_PROVIDER_COST" });
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_DELETE_PROVIDER_COST" });
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT"
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_DELETE_PROVIDER_COST" });
      });
  }

  calculateChildrenRowHeight() {
    if (this._utilService.isDesktop) {
      return this.childrenElementNumber * 37;
    } else {
      return this.childrenElementNumber * 90;
    }
  }
}
